import React from "react";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { deleteDepartment } from "./actions";
import { PermissionCheck } from "components/auth";
import { Actions, Targets } from "constants/Permissions";

const DeleteDepartment = ({
  as: As = Button,
  department,
  onDeleted,
  ...props
}) => (
  <ModalBuilder
    submitAction={deleteDepartment}
    submitParams={department.id}
    onSubmitted={onDeleted}
    renderTrigger={(showModal) => (
      <PermissionCheck target={Targets.Department} action={Actions.Delete}>
        <As onClick={showModal} {...props} />
      </PermissionCheck>
    )}
    renderModal={(modalProps) => (
      <Modal.Confirmation {...modalProps} header="Delete Department">
        Are you sure you wish to delete <b>{department.name}</b>?
      </Modal.Confirmation>
    )}
  />
);

export default DeleteDepartment;
